import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import LoginRegister from './forms/LoginRegister';

const RegistrationBlock = ({ text, t, path }) => (
  <RegistrationArea key="registration" id="aside-registration">
    <RegistrationInfo>
      <div>
        <Logo alt="Logo Art" src="/images/logo.svg" />
        <Register dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </RegistrationInfo>
    <RegisterForm>
      <LoginRegister
        path={path}
        labelLogin={<LabelLogin>{t('authorisation', { ns: 'index' })}</LabelLogin>}
      />
    </RegisterForm>
  </RegistrationArea>
);

const RegistrationArea = styled.div`
  margin-top: 80px;
  margin-bottom: 65px;
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
  border-radius: 30px;
  background: rgb(202, 217, 249);
  background: -moz-linear-gradient(
    145deg,
    rgba(202, 217, 249, 1) 0%,
    rgba(255, 255, 255, 1) 13%,
    rgba(255, 255, 255, 1) 31%,
    rgba(204, 234, 242, 1) 46%,
    rgba(104, 135, 218, 1) 73%
  );
  background: -webkit-linear-gradient(
    145deg,
    rgba(202, 217, 249, 1) 0%,
    rgba(255, 255, 255, 1) 13%,
    rgba(255, 255, 255, 1) 31%,
    rgba(204, 234, 242, 1) 46%,
    rgba(104, 135, 218, 1) 73%
  );
  background: linear-gradient(
    145deg,
    rgba(202, 217, 249, 1) 0%,
    rgba(255, 255, 255, 1) 13%,
    rgba(255, 255, 255, 1) 31%,
    rgba(204, 234, 242, 1) 46%,
    rgba(104, 135, 218, 1) 73%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#cad9f9",endColorstr="#6887da",GradientType=1);
  @media screen and (max-width: 750px) {
    grid-template-columns: 1fr;
    margin-bottom: 70px;
  }
  @media screen and (max-width: 600px) {
    border-radius: 20px;
    margin-top: 40px;
    margin-bottom: 30px;
  }
`;

const RegisterForm = styled.div`
  background-color: white;
  border-radius: 30px;
  padding: 40px 50px;
  display: flex;
  justify-content: center;
  align-content: center;
  form {
    display: grid;
    grid-gap: 15px;
    width: 100%;
  }
  .form-control {
    display: grid;
    padding: 18px 15px;
    align-items: center;
    grid-gap: 10px;
    height: 47px;
    border-radius: 10px;
    background: #f3f3f3;
    border-bottom: 0;
    font-size: 14px;
    font-weight: 500;
    color: var(--art-dark);
    &::placeholder {
      font-size: 14px;
      font-weight: 500;
    }
  }
  .input-group {
    .input-group-text {
      border-bottom: 0 !important;
      background-color: #f3f3f3 !important;
      border-radius: 0 10px 10px 0 !important;
    }
  }
  .PhoneInput {
    display: flex;
    align-items: center;
    background-color: #f3f3f3;
    padding: 9px 15px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    color: var(--art-dark);
    input {
      &::placeholder {
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
  .PhoneInputInput {
    flex: 1;
    min-width: 0;
    border: 0;
    background: transparent;
  }
  .PhoneInputCountryIcon {
    box-shadow: none;
    border: 0;
  }
  .invalid-feedback {
    position: absolute;
    bottom: -21px;
    font-size: 10px;
    left: 11px;
  }
  .btn {
    width: 100%;
    border-radius: 10px;
  }
  @media screen and (max-width: 812px) {
    .PhoneInputCountryIcon {
      font-size: 14px !important;
    }
    .PhoneInput {
      font-size: 14px !important;
      &::placeholder {
        font-size: 12px;
        font-weight: 500;
      }
    }
  }
  @media screen and (max-width: 768px) {
    padding: 20px;
    .form-control {
      height: 44px;
    }
  }
  @media screen and (max-width: 500px) {
    border-radius: 20px;
    padding: 15px;
    .PhoneInputCountryIcon {
      font-size: 12px !important;
    }
    .PhoneInput, .form-control {
      font-size: 12px !important;
      font-weight: 400;
      &::placeholder, input::placeholder {
        font-size: 12px;
        font-weight: 400;
      }
    }
  }
`;

const RegistrationInfo = styled.div`
  padding: 95px 130px;
  align-items: center;
  display: flex;
  justify-content: center;
  @media screen and (max-width: 1200px) {
    padding: 65px 95px;
  }
  @media screen and (max-width: 1000px) {
    padding: 45px 60px;
  }
  @media screen and (max-width: 768px) {
    padding: 20px;
  }
  @media screen and (max-width: 500px) {
    padding: 15px;
  }
`;

const LabelLogin = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  text-align: center;
  margin-bottom: 20px;
`;

const Logo = styled.img`
  max-width: 75px;
  margin-bottom: 20px;
`;

const Register = styled.div`
  h4 {
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%;
    margin-bottom: 30px;
  }
  p {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    strong,
    b {
      font-weight: 700;
    }
  }
  @media screen and (max-width: 600px) {
    h4 {
      font-size: 18px;
    }
    p {
      font-size: 14px;
    }
  }
`;

RegistrationBlock.propTypes = {
  t: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default RegistrationBlock;
